import { StyledPageTitleSubtitle } from "./index.styled";

interface PageTitleSubtitleProps {
  title: string;
  subtitle: string;
}

const PageTitleSubtitle = ({ title, subtitle }: PageTitleSubtitleProps) => {
  return (
    <StyledPageTitleSubtitle>
      <h1 className="title">{title}</h1>
      <p className="subtitle">{subtitle}</p>
    </StyledPageTitleSubtitle>
  );
};

export default PageTitleSubtitle;
